<template>
  <v-layout class="d-flex pa-2">
    <v-select :disabled="disabled"  style="max-width: 75px;" :items="countries" outlined dense hide-details item-value="dialCode" v-model="modelObj[dialCodeProp]" @change="countrySelected">
      <template v-slot:prepend-item>
        <v-text-field id="countryPhoneInputSearch" v-model="searchTerm" :placeholder="$t('message.common.search')" hide-details outlined dense clearable class="px-1" @input="searchCountries"></v-text-field>
      </template>
      <template v-slot:selection>
        <v-img height="18" :src="flag" contain></v-img>
      </template>
      <template v-slot:item="data">
        <span style="max-width: 20px; min-width: 20px" class="mr-2">
          <v-img height="12" :src="data.item.flag" contain></v-img>
        </span>
        <span :id="`countryOption_${data.item.name}`">{{ data.item.name }} ({{data.item.nativeName}}) {{ data.item.dialCode }}</span>
      </template>
    </v-select>
    <v-text-field :readonly="disabled" v-model="modelObj[numberProp]" dense hide-details outlined :rules="modelObj[numberProp] ? $_MobileNumberValidation : []" @change="$emit('change')" :label="label || ''" :prefix="`${modelObj[dialCodeProp]} `"
      append-icon="mdi-phone" @click:append="this.openDialer">
      <template #append>
        <slot name="append" />
      </template>
    </v-text-field>
  </v-layout>
</template>

<script>
import countries from '@/assets/json/countries.json'
export default {
  props: ['modelObj', 'numberProp', 'dialCodeProp', 'label', 'disabled'],
  data () {
    return {
      searchTerm: '',
      flag: null,
      countries: countries,
      countriesClone: countries
    }
  },
  mounted () {
    this.countrySelected()
  },
  methods: {
    openDialer () {
      window.open(`tel:${this.modelObj[this.dialCodeProp]}${this.modelObj[this.numberProp]}`)
    },
    searchCountries () {
      let countries = []
      if (!this.searchTerm) countries = [...this.countriesClone]
      else {
        countries = this.countriesClone.filter((country) => {
          return country.name.toLowerCase().includes(this.searchTerm.toLowerCase()) || country.dialCode.toLowerCase().includes(this.searchTerm.toLowerCase())
        })
      }
      let countryObj = countries.find(x => x.dialCode === this.modelObj[this.dialCodeProp])
      if (!countryObj) {
        countryObj = this.countriesClone.find(x => x.dialCode === this.modelObj[this.dialCodeProp])
        if (countryObj) countries.push(countryObj)
      }
      this.countries = [...countries]
    },
    countrySelected () {
      if (!this.modelObj[this.dialCodeProp]) this.modelObj[this.dialCodeProp] = '+47'
      const countryObj = this.countriesClone.find(x => x.dialCode === this.modelObj[this.dialCodeProp])
      if (countryObj != null) this.flag = countryObj.flag
    }
  }
}
</script>

<style>

</style>
